module.exports = __webpack_public_path__ + "static/media/1.8a103f20.jpg";